var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgData(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M916.918857 496.566857H70.509714v330.532572a36.571429 36.571429 0 0 0 36.571429 36.571428h699.977143a36.571429 36.571429 0 1 1 0 73.142857H73.142857a73.142857 73.142857 0 0 1-73.142857-73.142857V94.281143a73.142857 73.142857 0 0 1 73.142857-73.142857h251.611429a73.142857 73.142857 0 0 1 52.077714 21.796571l111.908571 113.590857a36.571429 36.571429 0 0 0 26.038858 10.898286H914.285714a73.142857 73.142857 0 0 1 73.142857 73.142857v521.508572a35.254857 35.254857 0 0 1-70.509714 0v-265.508572z m0-73.142857v-146.285714a36.571429 36.571429 0 0 0-36.571428-36.571429H501.321143a73.142857 73.142857 0 0 1-52.150857-21.796571l-111.908572-113.590857a36.571429 36.571429 0 0 0-25.965714-10.898286H107.081143a36.571429 36.571429 0 0 0-36.571429 36.571428v292.571429h846.409143z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgData);
export default __webpack_public_path__ + "static/media/data.2d3f1ec1aa39f16b4e30f6575e27800f.svg";
export { ForwardRef as ReactComponent };